import {createFeature, createReducer, on} from '@ngrx/store';
import {
  calcBtnClick,
  changeProjectInfoFieldSuccess,
  deleteProjectLogoFileSuccess,
  getProgressSuccsess,
  getProjectInfoSuccess,
  navBtnClick,
  setCalculationId,
  uploadProjectLogoFileSuccess
} from './project.actions';
import {updateBasicDataSuccess} from '../modules/basic-data/store';
import {IProjectState, ItemProgressSet} from '@shared/model/project';

// export interface IProjectState extends ILockValues {
//   id: number | null;
//   name: string;
//   currency_multiplication: string;
//   currency: string;
//   credits_tab: boolean;
//   leasings_tab: boolean;
//   own_capitals_tab: boolean;
//   capexs_tab: boolean;
//   financing_type: number | null;
//   can_balance_view: boolean;
//   can_load_files: boolean;
//   can_output_to_excel: boolean;
//   can_results_view: boolean;
//   can_view_rating: boolean;
//   working_capital_tab: boolean;
//   venture_tab: boolean;
//   nav_btn_click: number;
//   calc_id: number | null;
//   progress: IProgressResponse | {};
//   project_mode: string;
//   projectConfig: IProjectConfig | null;
//   max_variants: number;
// }

const initialState: IProjectState = {
  id: null,
  name: '',
  credits_tab: false,
  leasings_tab: false,
  own_capitals_tab: false,
  working_capital_tab: false,
  venture_tab: false,
  capexs_tab: true,
  financing_type: null,
  currency_multiplication: '',
  currency: '',
  can_balance_view: true,
  can_load_files: true,
  can_output_to_excel: true,
  can_results_view: true,
  can_view_rating: true,
  nav_btn_click: 0,
  calc_id: null,
  progress: {},
  project_mode: '',
  projectConfig: null,
  max_variants: 0,
  block_sales_plan: false,
  block_leasings: false,
  block_purshaces: false,
  block_special_modes: false,
  block_advanced_products: false,
  block_lead_generation: false,
  block_standard_taxes: false,
  block_schedule: false,
  block_distribution_ransom_payment: false,
  credit_capitalization: false,
  grace_period_credit: false,
  project_subscribers_count: 0,
  logo: null,
  show_rating_to_investors: false,
  current_user_subscribed_to_project: false
};

export const projectFeature = createFeature({
  name: 'project',
  reducer: createReducer(
    initialState,
    on(getProjectInfoSuccess, (state, {project, projectConfig}) => ({
      ...state, ...project, projectConfig,
      // TODO удалить, чтобы вернуть локеры
      can_balance_view: true,
      can_load_files: true,
      can_output_to_excel: true,
      can_results_view: true,
      can_view_rating: true,
    })),
    on(getProgressSuccsess, (state, action) => {
      const payload: any = action;
      const key: any = Object.keys(payload.progress).find((k) => {
        return ItemProgressSet.has(k);
      });
      let p = {...state.progress, ...{[key]: payload.progress}};
      return {...state, progress: p};
    }),
    on(updateBasicDataSuccess, (state, {data}) => {
      // NOTE: данные приходят как из контролов select (value по id: number), так и из конопок-чипсов (value:boolean).
      // поэтому для отображения вкладки по capex проверяется условие по id, соответсвуюющее выбору "без кап. затрат"
      switch (data.name) {
        case 'name':
          return {...state, name: data.value};
        case 'country':
          return {...state, region: null};
        case 'use_purchases':
          return {...state, working_capital_tab: data.value};
        case 'fin_source_credit':
          return {...state, credits_tab: data.value};
        case 'fin_source_equity':
          return {...state, own_capitals_tab: data.value};
        case 'fin_source_leasing':
          return {...state, leasings_tab: data.value};
        case 'fin_source_venture':
          return {...state, venture_tab: data.value};
        case 'financing_type':
          return {...state, capexs_tab: data.value !== 3 ? true : false};
        default:
          return state;
      }
    }),
    on(navBtnClick, (state) => ({...state, nav_btn_click: state.nav_btn_click + 1})),
    on(calcBtnClick, setCalculationId, (state, {calc_id}) => ({...state, calc_id})),
    on(uploadProjectLogoFileSuccess, (state, {file}) => {
      return {...state, logo: file};
    }),
    on(deleteProjectLogoFileSuccess, (state, {id}) => {
      return {...state, logo: null};
    }),
    on(changeProjectInfoFieldSuccess, (state, {data}) => ({...state, [data.name]: data.value})),
  ),
});
